import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { PostgreSqlV2Dataset } from 'app/model/dataset/postgre-sql-v2.dataset';
import { IAttribute } from 'shell-models-lib';

@Metamodel.model({
    name: __IS_FABRIC_DPE__ ? adfModelTypeMap.postgreSql.copySourceType : adfModelTypeMap.postgreSqlV2.copySourceType,
    display: [
        format(stringResources.ModelName_CopySourceTemplate, stringResources.PostgreSql_DisplayText),
        format(stringResources.ModelName_CopySourcesTemplate, stringResources.PostgreSql_DisplayText)
    ],
    tags: {
        datasetModel: [
            Metamodel.modelFor(PostgreSqlV2Dataset)
        ]
    }
})
export class PostgreSqlV2CopySource extends TabularCopySource {

    public static readonly QUERY_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'QUERY_TIMEOUT',
        display: stringResources.ModelName_Source_QueryTimeout_Min,
        accepts: ['String'],
        constraint: {
            minimum: 1,
            maximum: 1440
        }
    })
    public queryTimeout?: number = 120;
}
